import { refreshCartFragments, isBtnLocked } from "../../utils/cart-fragments";
import celebrate from "../../utils/celebrate";
import PageTransition from "../global/page-transition";

export default function initCartLifetime() {
    // Cocher l'upsell du mini-cart ajoute vraiment la licence lifetime au panier,
    // comme les CTA de la page Lifetime : le bloc disparaît et, une fois dans le
    // panier, le lifetime couvre toutes les autres lignes (facturées 0, grisées,
    // retirées au checkout — voir Collections::covered_cart_items). Délégué : la
    // checkbox est dans .widget_shopping_cart_content, remplacée à chaque
    // fragment refresh.
    document.addEventListener('change', function (e) {
        if (e.target.id !== 'mini_cart_upsell' || !e.target.checked) return;

        var section = e.target.closest('.js-mini-cart-upsell-section');
        if (section) section.hidden = true;

        var body = new FormData();
        body.append('product_id', e.target.value);
        body.append('quantity', 1);

        fetch('/?wc-ajax=add_to_cart', { method: 'POST', body: body })
            .then(function () {
                return refreshCartFragments();
            })
            .catch(function () {
                // Échec réseau : on ré-affiche le bloc pour pouvoir réessayer.
                if (section) section.hidden = false;
                e.target.checked = false;
            });
    });

    // Délégation : le bouton est dans .widget_shopping_cart_content,
    // remplacé à chaque fragment refresh.
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-checkout-btn');
        if (!btn) return;

        // Plain checkout link: keep ctrl/cmd-click (new tab) as a normal link.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        // This handler owns the navigation (page-transition skips .js-checkout-btn).
        e.preventDefault();
        PageTransition.go(btn.href, e, btn);
    });

    // CTA "Get Lifetime Access" (page Lifetime) et "Subscribe Now" (compte) :
    // ajoute la licence lifetime au panier sans quitter la page, puis ouvre le
    // side cart via l'event `added_to_cart`. La licence est sold individually,
    // donc si elle est déjà dans le panier l'add_to_cart échoue côté WC (sans
    // casser le panier). Un seul chemin de code pour les deux cas : on refresh
    // toujours les fragments après coup (no-op si le produit y était déjà) puis
    // on ouvre le panier.
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-subscribe-lifetime');
        if (!btn) return;

        e.preventDefault();
        if (isBtnLocked(btn)) return;
        btn.classList.add('loading');
        celebrate(btn, { level: 'strong' });

        var body = new FormData();
        body.append('product_id', btn.dataset.product_id);
        body.append('quantity', btn.dataset.quantity || 1);

        fetch('/?wc-ajax=add_to_cart', { method: 'POST', body: body })
            .then(function () {
                return refreshCartFragments();
            })
            .then(function () {
                if (window.jQuery) {
                    window.jQuery(document.body).trigger('added_to_cart');
                }
            })
            .finally(function () {
                btn.classList.remove('loading');
            });
    });
}
